import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { EncryptedStorageService } from '@elan/services/encrypted-storage.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private encryptedStorageService: EncryptedStorageService) { }

    canActivate(): boolean {
        const token: any = this.encryptedStorageService.getItem('token');

        if (token?.data?.access_token) {
            return true;
        }

        this.router.navigate(['/login']);
        return false;
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicGuard implements CanActivate {
    constructor(private router: Router, private encryptedStorageService: EncryptedStorageService) { }

    canActivate(): boolean {
        const token: any = this.encryptedStorageService.getItem('token');

        if (token?.data?.access_token) {
            this.router.navigate(['/user/dashboard']);
            return false;
        }

        return true;
    }
}